
export const fetchFaculties = async () => {
    const response = await fetch(SITE_PARAMS.api_url + '/wp-json/mendelu/v1/other/faculty', {
        method: 'GET',
        headers: new Headers({
            'Content-Type': 'application/json',
        }),
    });
    const result = await response.json();
    return result;
};

export const addCookiesSetting = async (cookiesId, configuration) => {
    const response = await fetch(SITE_PARAMS.site_url + '/wp-json/mendelu/v1/cookies/setting?cookiesId=' + cookiesId + '&configuration=' + configuration, {
        method: 'GET',
        headers: new Headers({
            'Content-Type': 'application/json',
        }),
    });
    const result = await response.json();
    return result;
};